module.exports = __webpack_public_path__ + "img/chinesecompany187.cef3f200.png";